import { css } from 'linaria';

export const classNames =  {
  root: css`
    overflow: hidden;
  `,
  animateHeight: css`
    flex: 1;
    flex-basis: auto;
  `,
};